// Author Liang Gang Qiang
// Date 2021-11-27 10:12:22

import * as model from "@/model/mintalMes/quality/MintalMesQualityProductionSampleItemModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesQualityProductionSampleItem(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_QUALITY_URL,
    })
    .buildStore()
